import { useQuarantineDefectTypeV1ControllerGetByProject } from 'generated/apiComponents';
import { useSession } from 'technical/auth/client';

export const useGetQuarantineDefectTypeData = () => {
  const { data: session } = useSession();

  const { data, error, isLoading } =
    useQuarantineDefectTypeV1ControllerGetByProject(
      {
        queryParams: {
          projectId: session?.user.projectId ?? '',
        },
      },
      {
        enabled: !!session?.user.projectId,
      },
    );

  return {
    data,
    loading: isLoading,
    error,
  };
};
